/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Hotjar from '@hotjar/browser';

import { releaseFlags } from '../../helpers/featuresFlags/featuresFlags';
import { userRoleCheckers } from '../../../shared/helpers';
import { usePrevious } from '../hooks';
import { GeneralActionCreators } from '../redux/actions/creators';
import { MeSelectors } from '../redux/selectors';

function checkRedirects(route, location, me, accessToken) {
  const redirects = [
    function redirectRootPath() {
      if (location.pathname === '/') {
        return <Navigate to={{ pathname: '/login' }} state={{ from: location }} replace />;
      }
      return null;
    },
    function redirectNotAuthUser() {
      if (
        !accessToken
        || !me._id
        || !me.isActive
      ) {
        return <Navigate to={{ pathname: '/login' }} state={{ from: location }} replace />;
      }
      return null;
    },
    function redirectWriterWithoutOnboarding() {
      if (
        userRoleCheckers.isWriter(me.role)
        && !me.interactions?.isOnboardingPassed
        && location.state?.from?.pathname === '/login'
      ) {
        return <Navigate to={{ pathname: '/account' }} state={{ from: location }} replace />;
      }
      return null;
    },
    // TODO: CHECK WHY THIS PART OF LOGIC DIDN'T WORK
    function redirectCustomerWithoutProject() {
      if (userRoleCheckers.isCustomer(me.role) && !me.project?.type) {
        return <Navigate to={{ pathname: '/no-project-for-customer' }} state={{ from: location }} replace />;
      }
      return null;
    },
    function redirectNotAllowedRoute() {
      const allowedRoute = me.allowedPageRoutes.find(r => r.path === route.path);
      if (!allowedRoute) {
        return <Navigate to={{ pathname: '/not-found' }} state={{ from: location }} replace />;
      }
      return null;
    },
    function redirectNotEnabledPath() {
      const routeParts = route.path.split('/');
      let routeKey = routeParts?.[1];
      let isRouteDisabledByFlags;
      if (routeKey === 'project') {
        routeKey = routeParts?.[3];
        isRouteDisabledByFlags = releaseFlags[me.role]?.project?.subRoutes?.[routeKey]?.isDisabled;
      } else {
        isRouteDisabledByFlags = releaseFlags[me.role]?.[routeKey]?.isDisabled;
      }
      const isRouteDisabled = releaseFlags.isFlaggingEnabled && isRouteDisabledByFlags;
      if (isRouteDisabled) {
        return <Navigate to={{ pathname: '/not-found' }} state={{ from: location }} replace />;
      }
      return null;
    },
  ];

  let redirect;
  redirects.some((func) => {
    redirect = func();
    return redirect;
  });

  return redirect;
}

const PrivateRoute = (props) => {
  const { route, children } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const me = useSelector(MeSelectors.selectMe);
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.stateChange(location.pathname);
    }
  }, [location.pathname]);

  function loadAndSetTranslationNamespace() {
    const { translationNamespace = i18next.Namespace.COMMON } = route;
    const { i18n } = useTranslation(translationNamespace);
    i18n.setDefaultNamespace(translationNamespace);
  }
  loadAndSetTranslationNamespace();

  // TODO: DEPRECATED
  const prevPath = usePrevious(route.path);
  if (prevPath !== route.path) {
    dispatch(GeneralActionCreators.resetStore());
  }

  const redirect = checkRedirects(route, location, me, accessToken);
  if (redirect) return redirect;

  return children;
};

export default PrivateRoute;
